export default "__VITE_ASSET__BksiqA3Q__"